/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'xAxis': {
    width: 17,
    height: 18,
    viewBox: '0 0 17 18',
    data: '<path pid="0" d="M8.783 7.636L6.737 4.763h1.015l1.552 2.256 1.547-2.256h1.004L9.81 7.636l2.154 3.013h-1.01L9.304 8.265 7.64 10.649H6.63l2.154-3.013z" _fill="#fff"/><path pid="1" opacity=".4" fill-rule="evenodd" clip-rule="evenodd" d="M.621 2.645a.502.502 0 000 .708.498.498 0 00.706 0l.71-.712v12.366a.5.5 0 101 0V2.73l.622.623a.498.498 0 00.706 0 .502.502 0 000-.708L2.846 1.122a.498.498 0 00-.706 0L.621 2.645z" _fill="#fff"/><path pid="2" fill-rule="evenodd" clip-rule="evenodd" d="M14.86 13.123a.498.498 0 00-.707 0 .502.502 0 000 .708l.71.713H2.534a.5.5 0 000 1h12.244l-.625.626a.502.502 0 000 .708.498.498 0 00.706 0l1.52-1.523a.502.502 0 000-.708l-1.52-1.524z" _fill="#fff"/>'
  }
})
